import PropTypes from "prop-types";

const MenuItemType = PropTypes.shape({
  classNames: PropTypes.string,
  dataAttributes: PropTypes.object.isRequired,
  group: PropTypes.string,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  trackAction: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});

export default MenuItemType;
